import { AvailableLanguage } from "../../../Interface/logoLang";
import FallbackKenkoSvg from "./logo_kenko_fr.svg";

// Imports statiques par langue : un import dynamique `./logo_kenko_${lang}.svg`
// forçait webpack à créer un context module (warning "Critical dependency").
const kenkoSvgLoaders: Record<
  AvailableLanguage,
  () => Promise<{ default: string }>
> = {
  fr: () => import("./logo_kenko_fr.svg"),
  en: () => import("./logo_kenko_en.svg"),
  de: () => import("./logo_kenko_de.svg"),
  es: () => import("./logo_kenko_es.svg"),
  nl: () => import("./logo_kenko_nl.svg"),
};

export async function getKenkoSvg(
  lang: AvailableLanguage = "fr"
): Promise<string> {
  const logoImport = await kenkoSvgLoaders[lang]?.().catch(() => {
    console.warn(
      `Kenko SVG for language ${lang} not found. Using fallback.`
    );
  });

  return logoImport
    ? logoImport?.default || FallbackKenkoSvg
    : FallbackKenkoSvg;
}

export default { getKenkoSvg };
